class NewFeaturedCollectionSlideown extends HTMLElement {
  constructor() {
    super();

    $(this).slick({
      slidesToShow: 4.5,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      infinite: false,
      centerMode: false,
      nextArrow:
        '<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" role="img" width="24px" height="24px" fill="none"><path stroke="currentColor" stroke-width="1.5" d="M8.474 18.966L15.44 12 8.474 5.033"></path></svg></button>',
      prevArrow:
        '<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" role="img" width="24px" height="24px" fill="none"><path stroke="currentColor" stroke-width="1.5" d="M15.525 18.966L8.558 12l6.967-6.967"></path></svg></button>',
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 3.5,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1.5,
            centerMode: false,
            dots: true,
            slidesToScroll: 1,
            touchThreshold: 100,
            speed: 200,
          },
        },
      ],
    });
  }
}

customElements.define(
  "featured-collection-slide",
  NewFeaturedCollectionSlideown
);
